import { TranslocoPipe } from '@jsverse/transloco';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonModule } from '@openng/optimus-ui/button';
import { RevealDirective } from '../../../shared/animations/reveal.directive';

@Component({
  selector: 'app-landing-cta',
  standalone: true,
  imports: [TranslocoPipe, RouterLink, ButtonModule, RevealDirective],
  template: `
    <section class="cta-band" appReveal [attr.aria-label]="'landing.getStarted' | transloco">
      <h2>{{ 'landing.readyToKnowYourGame' | transloco }}</h2>
      <a pButton routerLink="/register" class="cta-button"><span pButtonLabel>{{ 'landing.createFreeAccount' | transloco }}</span></a>
      <small>{{ 'landing.freeDuringLaunchNoCreditCardRequired' | transloco }}</small>
    </section>
  `,
  styles: [`
    .cta-band {
      background: var(--color-action);
      border: 1px solid color-mix(in srgb, var(--color-on-action) 18%, transparent);
      border-radius: var(--radius-card);
      box-shadow: var(--shadow-card);
      display: grid;
      gap: var(--space-5);
      justify-items: center;
      margin-inline: auto;
      overflow: hidden;
      padding: clamp(2.5rem, 6vw, 4.5rem) clamp(1.5rem, 4vw, 3rem);
      position: relative;
      text-align: center;
      width: min(100%, 74rem);
    }

    /* concentric net rings echoing the roundnet net */
    .cta-band::before {
      background:
        radial-gradient(circle at 88% 110%, transparent 58%, rgba(255, 255, 255, 0.07) 58.5%, rgba(255, 255, 255, 0.07) 64%, transparent 64.5%, transparent 72%, rgba(255, 255, 255, 0.06) 72.5%, rgba(255, 255, 255, 0.06) 78%, transparent 78.5%),
        radial-gradient(circle at 6% -22%, transparent 52%, rgba(255, 255, 255, 0.06) 52.5%, rgba(255, 255, 255, 0.06) 58%, transparent 58.5%, transparent 67%, rgba(255, 255, 255, 0.05) 67.5%, rgba(255, 255, 255, 0.05) 73%, transparent 73.5%);
      content: '';
      inset: 0;
      pointer-events: none;
      position: absolute;
    }

    h2, .cta-button, small { position: relative; }

    h2 {
      color: var(--color-on-action);
      font-size: clamp(1.9rem, 4vw, 3.2rem);
      letter-spacing: 0;
      line-height: 1.05;
      margin: 0;
    }

    .cta-button {
      background: var(--color-surface);
      border-color: var(--color-surface);
      color: var(--color-action);
      justify-content: center;
      min-height: var(--control-height-xl);
      padding-inline: var(--space-12);
      white-space: nowrap;
    }

    .cta-button:hover {
      background: var(--color-surface-high);
      border-color: var(--color-surface-high);
      color: var(--color-action);
    }

    small {
      color: color-mix(in srgb, var(--color-on-action) 85%, transparent);
      font-size: var(--font-size-caption);
      font-weight: 700;
    }

    :host-context([data-theme='dark']) .cta-band {
      background: color-mix(in srgb, var(--color-action) 12%, var(--color-surface-high));
      border-color: color-mix(in srgb, var(--color-action) 28%, var(--color-border-subtle));
    }

    :host-context([data-theme='dark']) h2 { color: var(--color-text-primary); }
    :host-context([data-theme='dark']) small { color: var(--color-text-secondary); }
    :host-context([data-theme='dark']) .cta-button {
      background: var(--color-action);
      border-color: var(--color-action);
      color: var(--color-on-action);
    }
  `],
})
export class LandingCtaComponent {}
